<template>
	<modal body-classes="p-0" :show="open" @close="close">
		<card type="secondary" class="border-0 mb-0">
			<template slot="header">
				<h2 class="text-center mb-0">เพิ่มบัญชี</h2>
			</template>
			<template>
				<form @submit.prevent="addBank">
					<base-input label="ชื่อบัญชี" placeholder="ชื่อบัญชี" v-model="accountName" />
					<base-input label="เลขบัญชี" placeholder="เลขบัญชี" v-model="accountNumber" />
					<base-input label="ธนาคาร">
						<el-select v-model="bank" placeholder="ธนาคาร">
							<el-option label="ธนาคารไทยพาณิชย์ (SMS)" value="scb_sms" />
							<el-option label="ธนาคารกสิกรไทย (SMS)" value="kbank_sms" />
							<el-option label="ทรูมันนี่วอลเล็ท" value="truewallet" />
						</el-select>
					</base-input>

					<div class="mt-3">
						<base-button native-type="submit" type="default" :disabled="loading">
							บันทึกข้อมูล
						</base-button>
					</div>
				</form>
			</template>
		</card>
	</modal>
</template>

<script>
import { Select, Option } from 'element-ui'

import { random, generateExternalAPI } from '../../util/url'
import { mapGetters } from 'vuex'
import SettingService from '../../services/setting.service'

export default {
	props: ['open'],
	components: {
		[Select.name]: Select,
		[Option.name]: Option,
	},
	data() {
		return {
			loading: false,
			accountName: '',
			accountNumber: '',
			bank: '',
		}
	},
	computed: {
		...mapGetters('auth', ['hasFeature']),
	},
	methods: {
		close() {
			this.$emit('close')
		},
		addBank() {
			this.loading = true
			SettingService.addBank({
				accountName: this.accountName,
				accountNumber: this.accountNumber,
				bank: this.bank.replace('_sms', ''),
			})
				.then(({ message }) => {
					this.$notify({
						type: 'success',
						message: message,
					})

					this.$emit('close')
					this.$emit('reloadSetting')
				})
				.catch(({ message }) => {
					this.$notify({
						type: 'danger',
						message: message,
					})
				})
				.finally(() => {
					this.loading = false
				})
		},
	},
	created() {
		this.bank = 'scb_sms'
	},
}
</script>
